import React from 'react';
import { Reveal } from './Reveal';
import { weekDays } from '../data/content';
export function WeekView() {
  return <section className="w-full bg-cream px-5 py-24 sm:py-32" data-id="element-219" data-mp="1mx5yu3iucn3n">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-220" data-mp="1rxle50moo4o9">
        <Reveal data-id="element-221" data-mp="1rxtu51e3rq3o">
          <h2 className="mx-auto max-w-3xl text-center font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-222" data-mp="1rv7iapk6iofn">
            Sådan ser en uge ud,{' '}
            <span className="font-serif text-[0.9em] normal-case italic text-red" data-id="element-223" data-mp="zahe7a2g6gjc">
              uden at forberede noget
            </span>
          </h2>
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-224" data-mp="1889uohjwnu8b">
          {weekDays.map((day, index) => <Reveal as="li" key={day.day} delay={index % 3 * 0.06} data-id="element-225" data-mp="1d1m61pzkq4j4" data-mpi={index}>
              <article className="flex h-full flex-col rounded-card border border-line bg-white p-7 shadow-card" data-id="element-226" data-mp="giyd58rzhcjy">
                <p className="font-display text-sm font-bold uppercase tracking-[0.18em] text-gold" data-id="element-227" data-mp="kifkk7qz0jrr">
                  {day.day}
                </p>
                <h3 className="mt-3 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-navy" data-id="element-228" data-mp="bahqdjxqvoen">
                  {day.title}
                </h3>
                <p className="mt-auto pt-3 text-base leading-relaxed text-muted" data-id="element-229" data-mp="6hx18vps9zhg">
                  {day.body}
                </p>
              </article>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}